import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { fg } from '@atlaskit/platform-feature-flags/fg';

type ErrorDetails = {
	message: string;
	stack?: string;
};
export type AnalyticsAttributes = Record<
	string,
	string | number | boolean | ErrorDetails | undefined | object
>;

interface FireAnalyticsProps {
	/**
	 * @deprecated Ignored when `platform-consolidated-cross-app-mau-experience` is enabled and will
	 * be removed once that flag is fully rolled out.
	 */
	actionSubjectId: string;
	/**
	 * @deprecated Ignored when `platform-consolidated-cross-app-mau-experience` is enabled and will
	 * be removed once that flag is fully rolled out.
	 */
	analyticsEventFireName: string;
	bridge: string;
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent;
	destinationApp: string;
	source: string;
	/**
	 * @deprecated Ignored when `platform-consolidated-cross-app-mau-experience` is enabled and will
	 * be removed once that flag is fully rolled out.
	 */
	tags: string[];
}

// An analytic to track custom cross app experiences (embedded, side-by-side, or a hand-off)
// This is needed as the useCrossProductUrlWrapper does not work with custom experiences
export const fireCustomCrossAppAnalytic = ({
	tags,
	destinationApp,
	createAnalyticsEvent,
	analyticsEventFireName,
	bridge,
	source,
	actionSubjectId,
}: FireAnalyticsProps): void => {
	const consolidatedCrossAppExperience = fg('platform-consolidated-cross-app-mau-experience');

	if (consolidatedCrossAppExperience) {
		const analyticsEvent = createAnalyticsEvent({
			action: 'viewed',
			actionSubject: 'customCrossAppExperience',
			eventType: 'ui',
			tags: ['navigationExperiences'],
			attributes: {
				bridge,
				source,
				destinationApp,
			},
		});

		// consolidate under one singular product. Had tried navigationExperiences but events weren't firing, hence, navigation
		analyticsEvent.fire('navigation');

		return;
	}
	const analyticsEvent = createAnalyticsEvent({
		action: 'customCrossAppExperience',
		actionSubject: 'viewed',
		actionSubjectId,
		eventType: 'ui',
		tags,
		attributes: {
			bridge,
			source,
			destinationApp,
		},
	});

	analyticsEvent.fire(analyticsEventFireName);
};
